import React from 'react';
export class CloudSolid extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("svg", { className: this.props.className || 'w-5 h-5', viewBox: '0 0 24 24', fill: 'currentColor', style: this.props.style },
                    React.createElement("path", { clipRule: 'evenodd', fillRule: 'evenodd', d: 'M4.5 9.75a6 6 0 0111.573-2.226 3.75 3.75 0 014.133 4.303A4.5 4.5 0 0118 20.25H6.75a5.25 5.25 0 01-2.23-10.004 6.072 6.072 0 01-.02-.496z' }))));
        };
    }
}
